// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as HarassmentDetails from './HarassmentDetails';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { HarassmentAllegations1Input } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: HarassmentAllegations1Mutation
// ====================================================

export interface HarassmentAllegations1Mutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface HarassmentAllegations1Mutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: HarassmentAllegations1Mutation_output_errors_extendedMessages[];
}

export interface HarassmentAllegations1Mutation_output_session_harassmentDetails {
  /**
   * Does you building have 2 apartments or less?
   */
  twoOrLessApartmentsInBuilding: boolean | null;
  /**
   * Is there more than one family living in each apartment?
   */
  moreThanOneFamilyPerApartment: boolean | null;
  /**
   * Explain how the landlord has harassed you.
   */
  harassmentDetails: string;
  /**
   * Whether the tenant alleges the landlord has FORCE.
   */
  allegForce: boolean;
  /**
   * Whether the tenant alleges the landlord has MISLEADING_INFO.
   */
  allegMisleadingInfo: boolean;
  /**
   * Whether the tenant alleges the landlord has STOPPED_SERVICE.
   */
  allegStoppedService: boolean;
  /**
   * Whether the tenant alleges the landlord has FAILED_TO_COMPLY.
   */
  allegFailedToComply: boolean;
  /**
   * Whether the tenant alleges the landlord has FALSE_CERT_REPAIRS.
   */
  allegFalseCertRepairs: boolean;
  /**
   * Whether the tenant alleges the landlord has CONDUCT_IN_VIOLATION.
   */
  allegConductInViolation: boolean;
  /**
   * Whether the tenant alleges the landlord has SUED.
   */
  allegSued: boolean;
  /**
   * Whether the tenant alleges the landlord has REMOVED_POSSESSIONS.
   */
  allegRemovedPossessions: boolean;
  /**
   * Whether the tenant alleges the landlord has INDUCED_LEAVING.
   */
  allegInducedLeaving: boolean;
  /**
   * Whether the tenant alleges the landlord has CONTACT.
   */
  allegContact: boolean;
  /**
   * Whether the tenant alleges the landlord has THREATS_RE_STATUS.
   */
  allegThreatsReStatus: boolean;
  /**
   * Whether the tenant alleges the landlord has REQUESTED_ID.
   */
  allegRequestedId: boolean;
  /**
   * Whether the tenant alleges the landlord has DISTURBED.
   */
  allegDisturbed: boolean;
}

export interface HarassmentAllegations1Mutation_output_session {
  harassmentDetails: HarassmentAllegations1Mutation_output_session_harassmentDetails | null;
}

export interface HarassmentAllegations1Mutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: HarassmentAllegations1Mutation_output_errors[];
  session: HarassmentAllegations1Mutation_output_session | null;
}

export interface HarassmentAllegations1Mutation {
  output: HarassmentAllegations1Mutation_output;
}

export interface HarassmentAllegations1MutationVariables {
  input: HarassmentAllegations1Input;
}

export const BlankHarassmentAllegations1Input: HarassmentAllegations1Input = {
  "allegForce": false,
  "allegMisleadingInfo": false,
  "allegStoppedService": false,
  "allegFailedToComply": false,
  "allegFalseCertRepairs": false,
  "allegConductInViolation": false,
  "allegSued": false
};

export const HarassmentAllegations1Mutation = {
  // The following query was taken from HarassmentAllegations1Mutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation HarassmentAllegations1Mutation($input: HarassmentAllegations1Input!) {
  output: harassmentAllegations1(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      harassmentDetails { ...HarassmentDetails }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}
${HarassmentDetails.graphQL}`,
  name: "HarassmentAllegations1Mutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: HarassmentAllegations1MutationVariables): Promise<HarassmentAllegations1Mutation> {
    return fetchGraphQL(HarassmentAllegations1Mutation.graphQL, args);
  },
  blankInput: BlankHarassmentAllegations1Input,
};

export const fetchHarassmentAllegations1Mutation = HarassmentAllegations1Mutation.fetch;